<template>
<div class="animated fadeIn">
    <div class="form-group row">
      <div class="col-md-9">
        <Forms ref="frmGroup"
          :title="'CONFIGURÇÃO AMBIENTE'"
          :showClearButton="true"
          :showSaveButton="true"
          v-on:Clear="clearInputs"
          v-on:Save="submitFile">

          <div class="form-group row pb-3 justify-content-around">
            <div class="col-md-6">
              <div class="input-group d-flex align-items-center">
                <label id="labelUpload" for="arquivoBg">Selecione Imagem Fundo</label>
                <input type="file" @change="uploadBackground" ref="fileBg" id="arquivoBg" accept="image/jpeg">
                <p class="pt-3 pl-3">{{ background && background.name}}</p>
              </div>
            </div>

            <div class="col-md-6">
              <div class="input-group d-flex align-items-center">
                <label id="labelUpload" for="arquivoLogo">Selecione Imagem Logo</label>
                <input type="file" @change="uploadLogo" ref="fileLogo" id="arquivoLogo" accept="image/jpeg">
                <p class="pt-3 pl-3">{{ logo && logo.name}}</p>
                <p class="position-relative"></p>
              </div>
            </div>
          </div>

          <div class="form-group row pb-3">

            <div class="col-md-6">
              <label for="txtName"> Posição menu Login:</label>
              <div class="input-group">
                <b-form-select v-model="posicao">
                  <template slot="first">
                    <option value="ESQUERDA">Esquerda</option>
                    <option value="CENTRO">Centro</option>
                    <option value="DIREITA">Direita</option>
                  </template>
                </b-form-select>
              </div>
            </div>

            <div class="col-md-6">
              <label for="tipoPermissao"><small style="color:red">*</small> Gestão de acesso:</label>
              <div class="input-group">
                <b-form-select v-model="tipoPermissao">
                  <template slot="first">
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                    <option value="GERENTESISBR">Gerente SisBR</option>
                    <option value="GERENTERELACIONAMENTO">{{$lang.RelationchipManager.Label}}</option>
                  </template>
                </b-form-select>
              </div>
            </div>

          </div>

          <div><p style="position:relative; top:30px;">As imagens devem ser no formato .png e o logo deve possuir proporção de 19x5</p></div>
        </Forms>
      </div>
    </div>
    <div v-if="hasWaitUpload">
      <div class="upload"></div>
      <div class="uploadText">
        <h2>
          <i class="fas fa-file-import"></i> Upload iniciado! <br>Aguarde um momento, por favor.<br>
          <small style="font-size: 12px;padding-top: 10px;">Essa mensagem será fechada ao final!</small>
        </h2>
      </div>
      <div class="upload-loading">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="upload-loading-img" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
          <g transform="translate(20 50)">
            <circle cx="0" cy="0" r="6" fill="#006a5b">
              <animateTransform attributeName="transform" type="scale" begin="-0.375s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
            </circle>
            </g><g transform="translate(40 50)">
            <circle cx="0" cy="0" r="6" fill="#04a791">
              <animateTransform attributeName="transform" type="scale" begin="-0.25s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
            </circle>
            </g><g transform="translate(60 50)">
            <circle cx="0" cy="0" r="6" fill="#abbd81">
              <animateTransform attributeName="transform" type="scale" begin="-0.125s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
            </circle>
            </g><g transform="translate(80 50)">
            <circle cx="0" cy="0" r="6" fill="#d1ddb5">
              <animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
            </circle>
          </g>
        </svg>
        <div class="text-center">
          <strong>Acompanhe abaixo o envio do arquivo:</strong>
          <url class="pt-3" v-for="(obj, index) in uploadingFiles" :key="index">
            <li v-if="obj.uploaded" class="pt-2"><i class="far fa-file-excel excel-color"></i> {{obj.file.name}} <i class="fas fa-check excel-color"></i></li>
            <li v-else class="pt-2"><i class="fas fa-upload text-third"></i> Enviando {{obj.file.name}} <b-spinner small label="Aguarde..." variant="success"></b-spinner></li>
          </url>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'
import EnvironmentRepository from '@/shared/http/repositories/access/environment'

export default {
  name: 'Environment',
  mixins: [ActionsForm],
  data () {
    return {
      background: null,
      logo: null,
      posicao: 'ESQUERDA',
      tipoPermissao: null
    }
  },
  computed: {
    hasWaitUpload () {
      return this.waitUpload
    }
  },
  methods: {
    uploadBackground () {
      this.background = this.$refs.fileBg.files[0]
    },
    uploadLogo () {
      this.logo = this.$refs.fileLogo.files[0]
    },
    submitFile () {
      if (this.checkIfNull()) {
        toast.warning('Selecione o tipo de gestão de acesso')
        return
      }
      this.waitUpload = true
      const formData = new FormData()
      const importData = {
        posicao: this.posicao,
        tipoPermissao: this.tipoPermissao
      }
      let json = new Blob([JSON.stringify(importData)], { type: 'application/json' })

      formData.append('background', this.background)
      formData.append('logo', this.logo)
      formData.append('data', json)

      EnvironmentRepository.Update(formData)
        .then(() => {
          toast.success('Ambiente alterado')
          this.$router.replace({ name: 'PaginaInicial' })
        })
        .catch(this.onException)
    },
    clearInputs () {
      this.logo = null
      this.background = null
      this.tipoPermissao = null
      this.posicao = 'ESQUERDA'
    },
    checkIfNull () {
      if (this.tipoPermissao == null) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
input[type="file"] {
    display: none;
}

#labelUpload {
    border-radius: 35px;
    padding: 20px 10px;
    background-color: #05A791;
    color: #FFF;
    text-transform: uppercase;
    text-align: center;
    display: block;
    margin-top: 10px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/environment/envinronment.vue